import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/customers");
    } catch (error) {
      alert("Invalid credentials");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0e1a2b",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "#1c2a3a",
          padding: "30px 20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
          width: "100%",
          maxWidth: "400px",
          color: "#fff",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Admin Login
        </h2>

        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          type="email"
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "5px",
            border: "1px solid #2c3e50",
            backgroundColor: "#243447",
            color: "#fff",
          }}
        />

        {/* <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          placeholder="Password"
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            border: "1px solid #2c3e50",
            backgroundColor: "#243447",
            color: "#fff",
          }}
        /> */}
        {/* Password input with eye icon */}
        <div
          style={{
            position: "relative",
            marginBottom: "20px",
          }}
        >
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            style={{
              width: "100%",
              padding: "10px 40px 10px 10px",
              borderRadius: "5px",
              border: "1px solid #2c3e50",
              backgroundColor: "#243447",
              color: "#fff",
            }}
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#ccc",
              fontSize: "18px",
              userSelect: "none",
            }}
          >
            {showPassword ? "Hide" : "Show"}
          </span>
        </div>

        <button
          onClick={handleLogin}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#ff9d00",
            color: "#000",
            fontWeight: "bold",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            marginBottom: "15px",
          }}
        >
          Login
        </button>

        <p style={{ textAlign: "center", fontSize: "14px" }}>
          <a
            href="/customers/forgot-password"
            style={{ color: "#fffffa", textDecoration: "underline" }}
          >
            Forgot Password?
          </a>
        </p>
      </div>
    </div>
  );
}

// import { useState } from "react";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { auth } from "../../firebase";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       navigate("/customers");
//     } catch (error) {
//       alert("Invalid credentials");
//     }
//   };

//   return (
//     <div>
//       <h2>Admin Login</h2>
//       <input
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         placeholder="Email"
//       />
//       <input
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         type="password"
//         placeholder="Password"
//       />
//       <button onClick={handleLogin}>Login</button>
//       <p>
//         <a href="/customers/forgot-password">Forgot Password?</a>
//       </p>
//     </div>
//   );
// }
